<template>
  <div>
    <apexchart
      v-if="series.some((v) => v > 0)"
      type="donut"
      height="460"
      :options="opts"
      :series="series"
    />
    <empty-state
      v-else
      icon="mdi-chart-donut"
      :title="$t('no_data')"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import EmptyState from "@/components/global/EmptyState.vue";

const SHIFT_COLORS = ["#1E88E5", "#43A047", "#FB8C00", "#8E24AA"];

export default {
  name: "MoreRestaurantsShiftsChart",
  components: { apexchart: VueApexCharts, EmptyState },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    series() {
      const totals = [0, 0, 0, 0];
      for (const c of this.orders) {
        totals[0] += c.totals.shift_one || 0;
        totals[1] += c.totals.shift_two || 0;
        totals[2] += c.totals.shift_three || 0;
        totals[3] += c.totals.shift_four || 0;
      }
      return totals;
    },
    opts() {
      return {
        chart: { type: "donut", fontFamily: "Roboto, sans-serif" },
        labels: this.shiftLabels,
        colors: SHIFT_COLORS,
        legend: { position: "bottom" },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`,
          dropShadow: { enabled: false },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "60%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: this.$t("total"),
                  formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
                },
              },
            },
          },
        },
        tooltip: { y: { formatter: (val) => `${val} ${this.$t("meal_meal")}` } },
      };
    },
  },
};
</script>
